import { useEffect, useState } from "react";
import axios from 'axios';
import { BASEURL } from "../../../constants";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { HorizontalThreeDots } from "../../Icons/icons";

const StudentCourseCard = ({ course, courseId, sharedCourseId ,  onClickHandler }) => {
    const [coverImage, setCoverImage] = useState("");
    const [isHovering, setIsHovering] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [completionPercentage , setCompletionPercentage] = useState(0);

    const navigate = useNavigate();

    
    function checkImageExists(imageUrl) {
        return new Promise((resolve, reject) => {
            const image = new Image();
            image.onload = () => resolve(true);
            image.onerror = () => reject(false);
            image.src = imageUrl;
        });
    }

    useEffect(() => {
        const fetchCourseCompletionPercentage = async () => {
            // what could go wrong
            const response = await axios.get(`${BASEURL}/api/get-course-completion-percentage` , {
                params:{
                    courseId: sharedCourseId
                }
            })
            setCompletionPercentage(response.data[0].course_completion_percentage);
        } 

        fetchCourseCompletionPercentage();
    } , [])


    useEffect(() => {

        async function getRequiredData() {
            // const fetchCourseInfo = await axios.get(`${BASEURL}/api/fetch-course-info`, {
            //     params: {
            //         courseId: courseId,
            //     },
            // })

            try {
                const response = await axios.post(`${BASEURL}/api/retrieve-cover-image`, { courseId: courseId });
                if (response.data.dataUrl) {
                    const imageExists = await checkImageExists(response.data.dataUrl);
                    if (imageExists) {
                        setCoverImage(response.data.dataUrl);
                    } else {
                        // console.log(`Image for course ${courseId} does not exist in S3 bucket`);
                        // images[course.id] = null; // or a default image URL
                    }
                } else {
                    // console.log(`No image URL received for course ${courseId}`);
                    // images[course.id] = null; // or a default image URL
                }

            } catch (error) {

            }
            // console.log("fetchCourseInfo for course id", courseId , fetchCourseInfo.data.rows)
            // setCourseInfo(fetchCourseInfo.data.rows)

        }

        getRequiredData()
    }, [courseId])
    
   

    return ( 
        <>
        {
            course && (
                <div className="transition-all duration-200 hover:translate-y-0.5 hover:shadow-hover w-[264px] h-[353px] relative flex flex-col justify-between border bg-white cursor-pointer"
                    onClick={() => {
                        onClickHandler(courseId , sharedCourseId);
                    }}

                    onMouseEnter={() => { setIsHovering(true) }}
                    onMouseLeave={() => { setIsHovering(false) }}

                >
                    <div className="h-[160px] text-center bg-gray-200">
                        {
                            coverImage ? (
                                <img
                                    src={coverImage}
                                    alt={`${coverImage} cover`}
                                    className="object-cover object-center w-full h-full"
                                />
                            ) : ('No Image available')
                        }
                    </div>
                    <div className="p-4 flex flex-col gap-4">
                        <div className="flex flex-col gap-2">
                            <div className="text-sm text-[#4F4F4F]">{course.first_name ? `${course.first_name} ${course.last_name}` : 'Diacto'}</div>
                            <div className="text-base font-bold h-[48px]">{course.course_name}</div>
                        </div>
                        <div>
                            <div className="h-[2px] w-full mb-2 bg-[#E0E0E0]">
                                {/* progress bar */}
                                <div className="bg-[#F2994A] h-[2px]" style={completionPercentage ? { width : `${completionPercentage}%`}:{ width : '0%'} }></div>
                            </div>
                            <div className="flex justify-between">
                                <div className="text-xs">
                                    <span>{completionPercentage ? `${completionPercentage}%`:`0%`}</span> 
                                    <span>COMPLETED</span>
                                </div>
                                <div className="text-xs">
                                    <span>4</span>/30 TOPICS
                                </div>
                            </div>
                        </div>
                        <div className="flex gap-2 overflow-x-hidden">
                            {
                                course.tags.map((tag) => {
                                    return <div className="px-2 py-1 max-w-[80px] truncate text-center border text-xs font-normal" title={`${tag}`}>{tag}</div>
                                })
                            }
                        </div>
                    </div>
                </div>
            )
        }
    </>
     );
}
 
export default StudentCourseCard;